import '../styles.css';
import { Prestador } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador';
import PrestadorCard from './PrestadorCard';
import DefaultText from '../../../../components/Accessibility/DefaultText';
import Calendar from '../../../../components/Calendar/Calendar';
import { useEffect, useState } from 'react';
import { getHorariosDisponiveisPeriodo } from '../../../../services/SaudeBemEstar/SaudeEmocionalService';
import dayjs from 'dayjs';
import moment from 'moment';
import { Horario } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Horario';
import WhiteContainer from '../../../../components/Accessibility/WhiteContainer';
import DefaultTextBold from '../../../../components/Accessibility/DefaultTextBold';
import { Radio, RadioGroup, useMediaQuery } from '@mui/material';
import { getDayNameExtenso } from '../../../../utils/DateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import TypographyAccessibility from '../../../../components/Accessibility/TypographyAccessibility';
import { sxBoxChevron, sxLabel } from './sxProps';
import { dateToText } from '../../../../utils/MonthMap';

const Step2SelecionarData: React.FC<{
  prestador: Prestador | undefined,
  onProsseguirClicked: (horarioSelecionado: Horario) => void,
  onVoltarClicked: () => void,
  disallowChange?: boolean,
}> = ({ prestador, onProsseguirClicked, onVoltarClicked, disallowChange }) => {

  const accessibility = useAccessibility();

  const [datesAvailable, setDatesAvailable] = useState<Horario[]>([]);
  const [hoursOptions, setHoursOptions] = useState<Horario[]>([]);
  const [hourSelected, setHourSelected] = useState<string>('');

  const mobile = useMediaQuery('(max-width: 1200px)');

  useEffect(() => {
    handleMonth(new Date())
  }, []);

  const handleDate = (date: Date) => {
    const dateString = moment(date).format('DD/MM/YYYY')
    const options = datesAvailable
      .filter(d => d.data === dateString)
    setHoursOptions(options);
  }

  const handleMonth = (date: Date) => {
    const month = date.getMonth()
    const start = moment(dayjs().month(month).startOf('month').toISOString()).format('DD/MM/YYYY');
    const end = moment(dayjs().month(month).endOf('month').toISOString()).format('DD/MM/YYYY');
    if (prestador) {
      getHorariosDisponiveisPeriodo(
        prestador.idPessoa, prestador.idInstal, start, end
      ).then(result => {
        setDatesAvailable(result)
      })
    }
  }

  const getHorarioCode = (h: Horario) => {
    return `${h.data} ${h.hora}`
  }

  const handleProsseguirClicked = () => {
    const datetime = hourSelected.split(' ')
    onProsseguirClicked({ data: datetime[0], hora: datetime[1] })
  }

  if (prestador) {
    return (
      <>
        <PrestadorCard
          prestador={prestador}
          showTitle
          button={
            disallowChange ?
              <div /> :
              <button className="editar-contato-button"
                onClick={onVoltarClicked}
                style={accessibility.textStyleAccessibility}
                aria-label={`trocar profissional ${prestador}`}
              >
                <FontAwesomeIcon icon={faChevronLeft} color="#00834F" style={{...accessibility.textStyleAccessibility, marginRight: '5px'}} />
                Trocar profissional
              </button>
          }
        />

        <div className='page-content'>
          <div >
            <TypographyAccessibility component="h2" sx={sxLabel} >
              Selecione uma data no calendário
            </TypographyAccessibility>
            <Calendar
              handleDate={handleDate}
              handleMonth={handleMonth}
              daysList={datesAvailable.map(h => h.data)}
              selectedDate={null} />
          </div>

          {
            !!hoursOptions.length &&
            <>
              {!mobile &&
                <div className="content-chevron">
                  <WhiteContainer shadow sx={sxBoxChevron}>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faChevronRight} />
                  </WhiteContainer>
                </div>
              }

              <div className={mobile ? 'flex-col align-center' : ''}>
                <DefaultTextBold component="h2" marginBottom="15px" text="Horários disponíveis" />
                <WhiteContainer shadow className="flex-col gap-10" style={{ padding: '30px', paddingRight: '60px' }}>
                  <DefaultTextBold text="Selecione o horário para agendamento" />
                  <RadioGroup 
                    className="flex-col gap-10"
                    aria-label="Selecione o horário para agendamento"
                  >
                  {
                    hoursOptions.map(h => {
                      const hourLabel = `${h.data} (${getDayNameExtenso(moment(h.data, 'DD/MM/YYYY').day())}) - ${h.hora}`
                      const hourLabelExtenso = `${dateToText(h.data)} (${getDayNameExtenso(moment(h.data, 'DD/MM/YYYY').day())}) - ${h.hora}`
                      return (
                        <div key={getHorarioCode(h)} className='flex-row'>
                          <Radio 
                            style={accessibility.contrastColorAccessibility} 
                            checked={hourSelected === getHorarioCode(h)} 
                            onChange={_ => { setHourSelected(getHorarioCode(h)) }}
                            inputProps={{ 'aria-label': hourLabelExtenso }}
                          />
                          <DefaultText text={hourLabel} />
                        </div>
                      )}
                    )
                  }            
                  </RadioGroup>
                </WhiteContainer>
              </div>

            </>
          }



        </div>

        <DefaultButton
          text="Prosseguir"
          disabled={!hourSelected}
          onClick={() => handleProsseguirClicked()} />

      </>

    )
  }

}

export default Step2SelecionarData;